import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable } from "react-table";
import { Document, Page, Text, StyleSheet } from "@react-pdf/renderer";
import India from "../../../assets/images/flags/india.png";
import Uk from "../../../assets/images/flags/uk.png";
import InfoGif from "../../../assets/images/GIF/question-mark.gif";
import { Table, Row, Col, Card, CardBody, Modal, Form } from "reactstrap";

import ContractAmendmentModal from "./ContractAmendmentModal";

// assets
import "../../../assets/css/Sales/Sales.css";
import "../../../assets/css/Sales/Contract.css";
import sideImg from "../../../assets/images/profile-img.png";

// common component
import Pagination from "components/Common/Pagination";
import ServerPagination from "components/Common/serverPagination";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import moment from "moment";
import DownloadContract from "./DownloadContract";
import configure from "configure";
import Select from "react-select";
import CopyToClipboard from "react-copy-to-clipboard";
import Swal from "sweetalert2";
import AccessDeniedPopup from "routes/AccessDeniedPopup";
import { fetchNodeData, FetchPostData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import { getInitials } from "utils/common-helpers";
import { axiosNodeInstance } from "utils/config";

import indiaFlag from "../../../assets/images/flags/india.png";
import usaFlag from "../../../assets/images/flags/usa.png";
import canadaFlag from "../../../assets/images/flags/canadian_flag.jpg";
// components

function TableContainer({
  columns,
  data,
  onFilter,
  clearFilter,
  onSaveFilter,
  setAccessDenied,
  setLoading,
  currentPage,
  limit,
  total,
  keyword,
  onPageChange,
  onLimitChange,
  onSearch,
  getPermissions,
}) {
  const [fixedContent, setFixedContent] = useState(false);
  const [formPopup, setFormPopup] = useState(false);
  const [location, setLocation] = useState([]);
  const [country, setCountry] = useState("");
  const [assign, setAssign] = useState([]);
  const [userIn_option, setUserIn] = useState([]);
  const [useruk_option, setUserUk] = useState([]);
  const [alluser_option, setAllUsers] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setFixedContent(window.scrollY > 165);
    };
    document.addEventListener("scroll", handleScroll);
    return () => document.removeEventListener("scroll", handleScroll);
  }, []);

  // Warm the shared permission cache (owned by the parent Contract
  // component, passed down as a prop) so it's ready before the first click.
  useEffect(() => {
    getPermissions().catch((err) => console.log(err));
  }, []);

  // `data` is already the current server-paginated page (see fetch() in the
  // parent Contract component, which now sends page/limit/keyword/filter to
  // the backend), so useTable is plain here -- no useGlobalFilter/
  // usePagination, which previously re-filtered/re-paginated the whole
  // already-fetched dataset client-side.
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  const debouncedSearch = useMemo(() => {
    let timer;
    return (value) => {
      clearTimeout(timer);
      timer = setTimeout(() => onSearch(value), 500);
    };
  }, [onSearch]);

  // getting Locations
  useEffect(() => {
    fetchCountry();
    FilterData();
  }, []);

  const fetchCountry = async () => {
    // setLoading(true)
    try {
      await axios({
        method: "get",
        url: `${configure.nodeApi}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        // console.log("country ",res.data)

        setLocation(
          res.data.locations.map((obj) => ({
            label: obj.location,
            value: obj.id,
          })),
        );
        // setLoading(false)
      });
    } catch (error) {
      console.log(error);
      // setLoading(false)
    }
  };

  const FilterData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/filter_data`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(async (response) => {
        setUserIn(
          response.data.data.india_user.map((obj) => ({
            value: obj.id,
            label: obj.name,
          })),
        );
        setUserUk(
          response.data.data.uk_user.map((obj) => ({
            value: obj.id,
            label: obj.name,
          })),
        );

        const users = [
          ...response.data.data.uk_user,
          ...response.data.data.india_user,
        ];

        const jsonObject = users.map(JSON.stringify);
        const uniqueSet = new Set(jsonObject);
        const uniqueArray = Array.from(uniqueSet).map(JSON.parse);
        setAllUsers(
          uniqueArray.map((obj) => ({
            value: obj.id,
            label: obj.name,
          })),
        );

        // ===============================================
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));

        const res = await axios.post(
          `${configure.nodeApi}/show_contract_filter`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );

        if (res.data.data !== "No Data found") {
          setCountry(JSON.parse(res.data.data[0].location));
          setAssign(JSON.parse(res.data.data[0].assigned));
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 1200,
    }),
  };

  const [name_modal, setNameModal] = useState(false);

  const [title, setTitle] = useState("");

  const info = [
    {
      title: "Assigned",
      mean: " <p> <strong>Meaning :</strong> In the Mars System's Contract Module, the  <strong>Assigned</strong>column designates the specific team member or individual responsible for managing and overseeing the contract, ensuring its fulfillment and compliance.</p>",
      purpose:
        " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong>  column is to establish accountability for the contract's execution and management. It helps streamline contract-related tasks, such as negotiations, amendments, and renewals, by identifying the team member or individual responsible. This column enhances teamwork, ensures effective contract administration within the Mars System, and facilitates timely contract execution.</p>",
    },
    {
      title: "Company",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Contract Module, the <strong>Company</strong>  column represents the name of the organization or business entity with which the contract is established.</p>",
      purpose:
        "<p> <strong>Purpose :</strong> The purpose of the <strong>Company</strong>  column is to provide specific identification of the contracting party. It ensures that the contract is associated with the correct company, streamlining record-keeping and facilitating clear communication and contract management within the Mars System. </p>",
    },
    {
      title: "Type",
      mean: "<p><strong>Meaning :</strong> The <strong>Type</strong> column in the Mars System's Contract Module categorizes contracts into different types, such as <strong>Website Development</strong>, <strong>Digital marketing</strong>, <strong>Dedicate resource </strong>  or other relevant categories </p>",
      purpose:
        "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Type</strong> column is to classify contracts based on their nature and purpose. It allows for easy categorization and sorting of contracts, ensuring that the Mars System users can quickly access and manage contracts based on their specific type. This column simplifies contract management and facilitates efficient contract retrieval.</p>",
    },
    {
      title: "Amount",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Contract Module, the <strong>Amount</strong> column specifies the currency in which the contract's financial terms and payments are denominated.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Amount</strong>  column is to provide transparency regarding the currency used in the contract's financial transactions. It ensures that both parties involved in the contract are aware of the currency terms, facilitating accurate financial record-keeping and transaction management within the Mars System.</p>",
    },
    {
      title: "Duration",
      mean: "<p><strong>Meaning :</strong> : In the Mars System's Contract Module, the <strong>Duration</strong>  column indicates the period or timeframe covered by the contract, including start and end dates.</p>",
      purpose:
        "<p><strong>Purpose :</strong>The purpose of the <strong>Duration</strong>   column is to specify the contract's temporal scope. It helps users understand when the contract commences and when it expires, facilitating timely contract monitoring, renewal, and compliance tracking within the Mars System.</p>",
    },
    {
      title: "Sent Date",
      mean: " <p><strong>Meaning :</strong>The <strong>Sent Date</strong> column records the date when the contract was sent to the relevant parties for review, approval, or signature.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Sent Date</strong> column is to track the initiation of the contract negotiation and approval process. It provides a reference point for measuring the time it takes for parties to respond and progress through the contract workflow within the Mars System.</p>",
    },
    {
      title: "End Date",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Contract Module, the <strong> End Date</strong> column denotes the date when the contract officially concludes or expires.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong> End Date </strong> column is to provide a clear indication of when the contract's obligations and terms come to an end. It assists in contract management by ensuring that both parties are aware of the contract's termination date within the Mars System.</p>",
    },
    {
      title: "Signature",
      mean: "<p><strong>Meaning :</strong> The <strong>Signature</strong>  column may be used to record whether the contract has been signed or executed by the relevant parties. It can include indicators like <strong>Signed </strong>, <strong>Not Signed </strong>, <strong>Pending </strong>, or <strong>Won </strong>.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong>Signature</strong> column is to track the status of contract execution. It helps users identify whether the contract has been legally binding and executed by all necessary parties. This column is crucial for ensuring compliance and contract validity within the Mars System.</p>",
    },
  ];

  const onAddPermission = async (id) => {
    setLoading(true);
    try {
      const data = await getPermissions();
      if (data.india[3] == 1 || data.uk[3] == 1) {
        navigate(`${configure.appUrl}sales/add-contract`);
      } else {
        setAccessDenied(true);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  // Render the UI for your table
  return (
    <div>
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          onClick={() => onAddPermission()}
          className="btn btn-save fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Contract</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-2">
        <Col>
          <select
            className=" me-4 form-select"
            style={{ width: "100px" }}
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </Col>
        <Col className="d-flex justify-content-end col-md-8">
          <div className="me-4">
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => debouncedSearch(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className=" form-control rounded h-100"
                    placeholder={` Search...`}
                    defaultValue={keyword || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end">
            <button
              onClick={() => setFormPopup(!formPopup)}
              className="btn btn-outline-secondary  me-3"
            >
              <i className="fas fa-filter"></i>
            </button>
            <Link
              onClick={() => onAddPermission()}
              // to={`${configure.appUrl}sales/add-contract`}
              className=" btn text-white me-2 btn-save btn-label"
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Contract
            </Link>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered mt-4" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-header" : ""
              } fix-contract-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true);
                          setTitle(column.Header);
                        }}
                      >
                        <i
                          title="info"
                          className="bx bx-info-circle ms-1 info-icon"
                        ></i>
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-contract-header" {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  className="row-hover position-relative"
                  {...row.getRowProps()}
                  key={i}
                >
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        onClick={() =>
                          cell.column.Header === "Company"
                            ? navigate(`${configure.appUrl}sales/edit-contract`)
                            : ""
                        }
                        className={`t-col-${index + 1} ${cell.column.className
                          } ${cell.column.Header === "Signature"
                            ? cell.value === "Not-Signed"
                              ? "text-danger"
                              : "text-success"
                            : ""
                          } ${cell?.row?.original?.approve == 2 ? "bg-red" : ""}`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}

                  {row?.original?.cancelled == 1 && (
                    <div className="strike-line"></div>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>

        {formPopup ? (
          <div className="popup-form contract-form-filter p-4">
            <Form
              onSubmit={(e) => {
                e.preventDefault();

                if (assign.length > 0 && country) {
                  setFormPopup(false);
                  onFilter(assign, country);
                } else {
                  Swal.fire(
                    "",
                    "Location and Assigned Fields Required",
                    "warning",
                  );
                }
              }}
            >
              <Row className="align-items-end">
                <Row className="d-flex pe-0 me-0" style={{ width: "100%" }}>
                  <div className="col-md-3 mb-2">
                    <label htmlFor="">Location</label>
                    <Select
                      placeholder="Select Location"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      onChange={(e) => setCountry(e)}
                      value={country}
                      styles={colourStyles}
                      options={location}
                    />
                  </div>

                  <div className="col-md-3 mb-2">
                    <label htmlFor="">Assigned</label>
                    {country.value == "2" ? (
                      <Select
                        placeholder="Select Assigned"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        options={useruk_option}
                        value={assign}
                        closeMenuOnSelect={false}
                        isMulti
                        onChange={(e) => setAssign(e)}
                      />
                    ) : country.value == "1" ? (
                      <Select
                        placeholder="Select Assigned"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        options={userIn_option}
                        value={assign}
                        closeMenuOnSelect={false}
                        isMulti
                        onChange={(e) => setAssign(e)}
                      />
                    ) : (
                      <Select
                        placeholder="Select Assigned"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        styles={colourStyles}
                        options={alluser_option}
                        value={assign}
                        closeMenuOnSelect={false}
                        isMulti
                        onChange={(e) => setAssign(e)}
                      />
                    )}
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="">Save and Clear Filters</label>
                    <div>
                      <a
                        className="btn  btn-primary mr-10"
                        onClick={() => onSaveFilter(assign, country)}
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#93a6ff",
                          borderColor: "#93a6ff",
                          color: "black",
                        }}
                      >
                        Save Filters
                      </a>
                      <a
                        className="btn  btn-danger"
                        onClick={() => {
                          setAssign([]);
                          setCountry("");
                          clearFilter();
                        }}
                        style={{
                          fontSize: "11px",
                          backgroundColor: "#fed36d",
                          borderColor: "#fed36d",
                          color: "black",
                        }}
                      >
                        Clear Filters
                      </a>
                    </div>
                  </div>
                  <div className="d-flex col-md-3 align-items-center justify-content-end mt-3">
                    <div className="mr-10">
                      <button className="btn  btn-purple">
                        <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                        Filter
                      </button>
                    </div>
                    <div className="">
                      <a
                        className="btn  btn-red"
                        onClick={(e) => {
                          e.preventDefault();
                          // setDatas(displayData)
                          setFormPopup(false);
                        }}
                      >
                        <i className="dripicons-cross me-1 icon-center"></i>{" "}
                        Close
                      </a>
                    </div>
                  </div>
                </Row>
                {/* <div
                                  className="text-end pe-0"
                                  style={{ width: "10%" }}
                                >
                                  <button className="btn  btn-purple mb-3">
                                    <i className="fas fa-filter search-icon me-1 icon-center"></i>{" "}
                                    Filter
                                  </button>
                                  <div>
                                    <a
                                      className="btn  btn-red"
                                      onClick={e => {
                                        e.preventDefault()
                                        setDatas(displayData)
                                        setFormPopup(!formPopup)
                                      }}
                                    >
                                      <i className="dripicons-cross me-1 icon-center"></i>{" "}
                                      Clear
                                    </a>
                                  </div>
                                </div> */}
              </Row>
            </Form>
            <i className="bi bi-triangle-fill pop-icon"></i>
          </div>
        ) : null}
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <ServerPagination
          currentPage={currentPage}
          pageSize={limit}
          totalItems={total}
          onPageChange={onPageChange}
        />
      </Row>

      <Modal
        isOpen={name_modal}
        toggle={() => {
          tog_center();
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            {title}
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                {info.map((item, i) => {
                  if (item.title == title) {
                    return (
                      <div key={i}>
                        <span>
                          <span
                            dangerouslySetInnerHTML={{ __html: item.mean }}
                          ></span>
                        </span>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.purpose }}
                        ></div>
                      </div>
                    );
                  }
                })}
                <div></div>
                <div className="text-center mt-70">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setNameModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

const generateAndDownloadPDF = () => {
  const pdfDoc = (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.text}>Hello, PDF World!</Text>
      </Page>
    </Document>
  );

  // Generate a blob from the PDF content
  // pdfDoc.toBlob(blob => {
  //   // Save the blob as a PDF file
  //   saveAs(blob, "myPDF.pdf")
  // })
};

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "white",
  },
  text: {
    marginTop: 30,
    marginLeft: 30,
  },
});

const flags = {
  1: indiaFlag,
  3: usaFlag,
  4: canadaFlag,
};

const Contract = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [amendmentModal, setAmendmentModal] = useState(false);
  const [amendmentContract, setAmendmentContract] = useState(null);
  const [versionSummary, setVersionSummary] = useState({});

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  //meta title
  document.title = "Contract | Zithas Crm";

  const [data, setDatas] = useState([]);
  const [filteredData, setFilteredDatas] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [modal_Access, setAccessDenied] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonModal, setReasonModal] = useState(false);
  const [cancelData, setCancelData] = useState({});

  const [logsModal, setLogsModal] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const navigate = useNavigate();

  const [permissions, setPermissions] = useState(null);

  // Fetches india[]/uk[] permission flags once and caches them, so the
  // add/edit/delete actions (in `columns` below, and in TableContainer's own
  // "Add Contract" button) don't each re-hit /user_permission on click.
  const getPermissions = async () => {
    if (permissions) return permissions;
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("module_id", 20);

    const res = await axios({
      method: "post",
      url: `${configure.nodeApi}/user_permission`,
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
    setPermissions(res.data.data);
    return res.data.data;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [assignFilter, setAssignFilter] = useState([]);
  const [countryFilter, setCountryFilter] = useState(null);

  // `columns` is memoized with an empty dependency array, so closures made
  // inside it (delete/cancel/etc.) would otherwise capture currentPage/limit/
  // keyword from the very first render forever. They read from this ref
  // instead so a refetch after an action always targets the actually-active
  // page/search/filter, not stale values.
  const paginationRef = useRef({
    currentPage: 1,
    limit: 50,
    keyword: "",
    assignFilter: [],
    countryFilter: null,
  });

  const [copyOrigSign, setCopyOrigSign] = useState("");
  const [copyAmendSign, setCopyAmendSign] = useState("");

  function flashCopy(setter) {
    setter("Copied!");
    setTimeout(() => setter(""), 1200);
  }

  useEffect(() => {
    fetch(1, limit, "", [], null);
    fetchVersionSummary();
    getPermissions().catch((err) => console.log(err));
  }, []);
  const toggleLoading = (loadin) => {
    setLoading(loadin);
  };

  const fetch = async (
    page = currentPage,
    pageLimit = limit,
    search = keyword,
    assign = assignFilter,
    country = countryFilter,
  ) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("page", page);
    formData.append("limit", pageLimit);
    formData.append("keyword", search);
    if (assign?.length) formData.append("assign", JSON.stringify(assign.map((a) => a.value)));
    if (country?.value) formData.append("location", country.value);
    try {
      const response = await axios({
        data: formData,
        method: "post",
        url: `${configure.nodeApi}/contract`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setDatas(response.data.data.contract);
        setFilteredDatas(response.data.data.contract);
        setTotal(response.data.data.total || 0);
        setCurrentPage(page);
        setLimit(pageLimit);
        setKeyword(search);
        setAssignFilter(assign || []);
        setCountryFilter(country || null);
        paginationRef.current = {
          currentPage: page,
          limit: pageLimit,
          keyword: search,
          assignFilter: assign || [],
          countryFilter: country || null,
        };
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const fetchVersionSummary = async () => {
    try {
      const res = await axios.get(
        `${configure.nodeApi}/contract_amendment/versions_summary`,
      );
      if (res.data.success) setVersionSummary(res.data.data);
    } catch (err) {
      console.error("Failed to fetch version summary:", err);
    }
  };

  // on main filter -- now applied server-side (data is only the current
  // page), so this refetches page 1 with the assign/location filter instead
  // of filtering the already-loaded page in memory.
  const onFilter = (assign, country) => {
    fetch(1, limit, keyword, assign, country);
  };

  const clearFilter = async () => {
    fetch(1, limit, keyword, [], null);
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("user_id", localStorage.getItem("auth_id"));

      const res = await axios.post(
        `${configure.nodeApi}/clear_contract_filter`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setLoading(false);

      Swal.fire("", "Filter Cleared Successfully!", "success");
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onSaveFilter = async (assign, country) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("assigned", JSON.stringify(assign));
      formData.append("location", JSON.stringify(country));
      formData.append("user_id", localStorage.getItem("auth_id"));

      const res = await axios.post(
        `${configure.nodeApi}/save_contract_filter`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setLoading(false);
      Swal.fire("", "Filter Saved Successfully!", "success");
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onDeleteLead = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete this Contract !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
      showCancelButton: true,
    }).then(async (willDelete) => {
      if (willDelete.isConfirmed) {
        setLoading(true);
        const formData = new FormData();
        formData.append("user_id", localStorage.getItem("auth_id"));
        formData.append("contract_id", id);
        try {
          const response = await axios({
            method: "post",
            url: `${configure.nodeApi}/delete_contract`,
            data: formData,
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          }).then((response) => {
            Swal.fire({
              icon: "success",
              text: "Contract Deleted Successfully",
            }).then(() => {
              fetch(
                paginationRef.current.currentPage,
                paginationRef.current.limit,
                paginationRef.current.keyword,
                paginationRef.current.assignFilter,
                paginationRef.current.countryFilter,
              );
            });
            setLoading(false);
          });
        } catch (err) {
          console.log(err);
          Swal.fire({
            icon: "error",
            text: "SomeThing Went Wrong",
          });
          setLoading(false);
        }
      }
    });
  };

  const onCancelContract = (id, cancelled) => {
    if (!id) return swal("", "Invalid Function call", "warning");

    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${cancelled == 0 ? "Cancel" : "Re-initiate"
        } this Contract !`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      showCancelButton: true,
    }).then(async (willDelete) => {
      if (willDelete.isConfirmed) {
        setLoading(true);
        try {
          const response = await axiosNodeInstance.patch(
            `/contract/cancel/${id}`,
            {
              auth_id: localStorage.getItem("auth_id"),
              reason,
            },
          );

          if (response.data.success) {
            setCancelData({});
            setReasonModal(false);
            setReason("");
            Swal.fire({
              icon: "success",
              text: `Contract ${cancelled == 0 ? "Cancelled" : "Re-initiated"
                } Successfully`,
            }).then(() => {
              setFilteredDatas((prev) =>
                prev.map((item) => {
                  if (item.id == id) {
                    item.cancelled = item.cancelled == 1 ? 0 : 1;
                  }
                  return item;
                }),
              );
            });
          }
        } catch (err) {
          console.log(err);
          Swal.fire({
            icon: "error",
            text: "SomeThing Went Wrong",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const getCancelLogs = async (id) => {
    const res = await fetchNodeData(setLoading, `contract/logs/${id}`);
    if (res.success) {
      setLogsData(res.data?.reverse() || []);
      setLogsModal(true);
    }
  };

  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center",
      },
      // {
      //   Header: "Assigned",
      //   accessor: "assign",
      //   Cell: (cellProps) => {
      //     return (
      //       <div className="text-center d-flex align-items-center">
      //         <div className="profileImg-box">
      //           {cellProps.row.original.img ? (
      //             <img
      //               src={`${configure.imgUrl}${cellProps.row.original.img}`}
      //               alt=""
      //               className="assigned-img mx-1"
      //               width="20"
      //               height="20"
      //             />
      //           ) : (
      //             <div
      //               className="defualt-img"
      //               title={cellProps.row.original.assigned_name}
      //             >
      //               {getInitials(cellProps.row.original.assigned_name || "Z")}
      //             </div>
      //           )}
      //           <div className="profileImg-detail">
      //             <div className="overflow-hidden mb-0 card">
      //               <div className="bg-primary bg-soft">
      //                 <div className="row">
      //                   <div className="col-8">
      //                     <div className="text-primary text-start p-3">
      //                       <h5 className="text-primary ">
      //                         {cellProps.row.original.assigned_name}
      //                       </h5>
      //                       <p style={{ width: "200px" }}>
      //                         {cellProps.row.original.assigned_designation}
      //                       </p>
      //                     </div>
      //                   </div>
      //                   <div className="align-self-end col-4">
      //                     <img src={sideImg} alt="" className="img-fluid" />
      //                   </div>
      //                 </div>
      //               </div>
      //               <div className="pt-0 mb-0 card-body">
      //                 <div className="row">
      //                   <div className="col-sm-12">
      //                     <div className="avatar-md profile-user-wid mb-2">
      //                       <img
      //                         src={`https://mars.zithas.com/application/public/${cellProps.row.original.img}`}
      //                         alt=""
      //                         style={{ width: "100%", height: "100%" }}
      //                         className="img-thumbnail rounded-circle"
      //                       />
      //                     </div>
      //                   </div>
      //                   <div className="col-sm-12">
      //                     <div className=" text-start">
      //                       <div className="row">
      //                         <div className="pe-1 col-5">
      //                           <h5 className="font-size-12 mb-1">Join Date</h5>
      //                           <p className=" font-size-12 text-muted mb-0">
      //                             {moment(
      //                               cellProps.row.original
      //                                 ?.assigned_joiningdate,
      //                             ).format("DD-MM-YYYY")}
      //                           </p>
      //                         </div>
      //                         <div className="ps-0 col-7">
      //                           <h5 className="font-size-12 mb-1">Email</h5>
      //                           <p className=" font-size-12 text-muted mb-0">
      //                             {cellProps.row.original.assigned_email}
      //                           </p>
      //                         </div>
      //                       </div>
      //                     </div>
      //                   </div>
      //                 </div>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //         {/* {cellProps.row.original.location ? (
      //           <img
      //             src={flags[cellProps.row.original.location]}
      //             className=" mx-1 location-img"
      //             // alt="flag"
      //             width="20"
      //             height="15"
      //           />
      //         ) : (
      //           <img
      //             src={flags[1]}
      //             className=" mx-1 location-img"
      //             // alt="flag"
      //             width="20"
      //             height="15"
      //           />
      //         )} */}
      //         {cellProps.row.original.location == 1 ? (
      //           <img
      //             src={India}
      //             className="mx-1 location-img"
      //             alt="flag"
      //             width="20"
      //             height="15"
      //           />
      //         ) : cellProps.row.original.location == 2 ? (
      //           <img
      //             src={Uk}
      //             className="mx-1 location-img"
      //             alt="flag"
      //             width="20"
      //             height="15"
      //           />
      //         ) : null}
      //       </div>
      //     );
      //   },
      //   isInfoIcon: true,
      // },
      {
        Header: "Assigned",
        accessor: "assign",
        Cell: (cellProps) => {
          const contractId = cellProps.row.original.id;
          const summary = versionSummary[contractId] || {};
          const amendmentCount = summary.has_amendments
            ? (summary.version_count - 1)   // version_count includes the original
            : 0;

          return (
            <div className="text-center d-flex align-items-center gap-1 flex-wrap">
              <div className="profileImg-box">
                {cellProps.row.original.img ? (
                  <img
                    src={`${configure.imgUrl}${cellProps.row.original.img}`}
                    alt=""
                    className="assigned-img mx-1"
                    width="20"
                    height="20"
                  />
                ) : (
                  <div
                    className="defualt-img"
                    title={cellProps.row.original.assigned_name}
                  >
                    {getInitials(cellProps.row.original.assigned_name || "Z")}
                  </div>
                )}
                {/* ── hover card (unchanged) ── */}
                <div className="profileImg-detail">
                  <div className="overflow-hidden mb-0 card">
                    <div className="bg-primary bg-soft">
                      <div className="row">
                        <div className="col-8">
                          <div className="text-primary text-start p-3">
                            <h5 className="text-primary">
                              {cellProps.row.original.assigned_name}
                            </h5>
                            <p style={{ width: "200px" }}>
                              {cellProps.row.original.assigned_designation}
                            </p>
                          </div>
                        </div>
                        <div className="align-self-end col-4">
                          <img src={sideImg} alt="" className="img-fluid" />
                        </div>
                      </div>
                    </div>
                    <div className="pt-0 mb-0 card-body">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="avatar-md profile-user-wid mb-2">
                            <img
                              src={`https://mars.zithas.com/application/public/${cellProps.row.original.img}`}
                              alt=""
                              style={{ width: "100%", height: "100%" }}
                              className="img-thumbnail rounded-circle"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="text-start">
                            <div className="row">
                              <div className="pe-1 col-5">
                                <h5 className="font-size-12 mb-1">Join Date</h5>
                                <p className="font-size-12 text-muted mb-0">
                                  {moment(cellProps.row.original?.assigned_joiningdate).format("DD-MM-YYYY")}
                                </p>
                              </div>
                              <div className="ps-0 col-7">
                                <h5 className="font-size-12 mb-1">Email</h5>
                                <p className="font-size-12 text-muted mb-0">
                                  {cellProps.row.original.assigned_email}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ── flag ── */}
              {cellProps.row.original.location == 1 ? (
                <img src={India} className="mx-1 location-img" alt="flag" width="20" height="15" />
              ) : cellProps.row.original.location == 2 ? (
                <img src={Uk} className="mx-1 location-img" alt="flag" width="20" height="15" />
              ) : null}

              {/* ── amendment count badge (only when amendments exist) ── */}
              {summary.has_amendments && (
                <span
                  className="badge"
                  title={`${amendmentCount} amendment${amendmentCount !== 1 ? "s" : ""}`}
                  style={{
                    fontSize: "9px",
                    background: "#752a97",
                    color: "#fff",
                    letterSpacing: "0.02em",
                    padding: "3px 5px",
                  }}
                >
                  {amendmentCount}A
                </span>
              )}
            </div>
          );
        },
        isInfoIcon: true,
      },
      {
        Header: "Company",
        accessor: "company_name",
        isInfoIcon: true,
        className: "cursor-pointer",
        Cell: (cellProps) => {
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {cellProps.row.original.company_name}
            </div>
          );
        },
      },
      {
        Header: "Type",
        accessor: "type",
        isInfoIcon: true,
        Cell: (cellProps) => {
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {cellProps.row.original.type}
            </div>
          );
        },
      },
      {
        Header: "Amount",
        accessor: "value",
        isInfoIcon: true,
        className: "text-center",
        Cell: (cellProps) => {
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {cellProps.row.original.value != null ? (
                <>
                  {cellProps.row.original.currency_symbol || "-"}{" "}
                  {cellProps.row.original.value}
                </>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: "Duration",
        accessor: "duration",
        isInfoIcon: true,
        Cell: (cellProps) => {
          const startDate = new Date(cellProps.row.original.startdate);
          const endDate = new Date(cellProps.row.original.enddate);
          const timeDifference = endDate - startDate;
          const daysDifference = Math.floor(
            timeDifference / (1000 * 60 * 60 * 24),
          );
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {daysDifference} days
            </div>
          );
        },
      },
      {
        Header: "Sent Date",
        accessor: "startdate",
        isInfoIcon: true,
        Cell: (cellProps) => {
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {cellProps.row.original?.startdate != null
                ? moment(cellProps.row.original?.startdate).format("DD-MM-YYYY")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "End Date",
        accessor: "enddate",
        isInfoIcon: true,
        Cell: (cellProps) => {
          return (
            <div
              className={`${cellProps.row.original.cancelled == 1 &&
                "text-decoration-line-through text-danger"
                }`}
            >
              {cellProps.row.original?.enddate != null
                ? moment(cellProps.row.original?.enddate).format("DD-MM-YYYY")
                : "-"}
            </div>
          );
        },
      },
      {
        Header: "Signature",
        accessor: "signature",
        isInfoIcon: true,
        Cell: (cellProps) => {
          return (
            <div className="text-danger text-center">
              {cellProps.row.original.cancelled == 1 ? (
                <span className="fw-bold">
                  <i className="fa fa-times-circle "></i> Cancelled
                </span>
              ) : (
                <Badge
                  className={
                    cellProps.row.original.signature == "signed"
                      ? "bg-success text-capitalize"
                      : "bg-danger text-capitalize"
                  }
                >
                  {cellProps.row.original.signature}
                </Badge>
              )}
            </div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (cellProps) => {
          const onPermission = async (callBack, id, cancelled) => {
            setLoading(true);
            try {
              const data = await getPermissions();
              if (data.india[5] == 1 || data.uk[5] == 1) {
                if ([0, 1].includes(cancelled)) {
                  if (cancelled == 1) callBack(id, cancelled);
                  else {
                    setCancelData({ id, cancelled });
                    setReasonModal(true);
                  }
                } else callBack(id);
              } else {
                setAccessDenied(true);
              }
              setLoading(false);
            } catch (error) {
              console.log(error);
              setLoading(false);
            }
          };

          const onGenerateLink = (e) => {
            Swal.fire({
              title: "Are you sure?",
              text: "You want to Generate Link !",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then(async (willDelete) => {
              if (willDelete.isConfirmed) {
                setLoading(true);
                
                const formData = new FormData();
                formData.append("contract_id", cellProps.row.original.id);
                formData.append("user_id", localStorage.getItem("auth_id"));
                try {
                  const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/contract_link`,
                    data: formData,
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }).then((response) => {
                    Swal.fire({
                      icon: "success",
                      text: "Link Generated Successfully",
                    }).then((data) => {
                      window.open(
                        `${configure.appUrl}sales/contract/${response.data.data}`,
                        "_blank",
                      );
                    });
                    setLoading(false);
                  });
                } catch (err) {
                  Swal.fire({
                    icon: "error",
                    text: "SomeThing Went Wrong",
                  });
                  setLoading(false);
                }
              }
            });
          };

          const [copy, setCopy] = useState("");
          const [copy2, setCopy2] = useState("");
          function copyToClipBoard(type) {
            if (type == 1) {
              setCopy("Copied ! ...");
            } else {
              setCopy2("Copied ! ...");
            }
            setTimeout(() => {
              if (type == 1) {
                setCopy("");
              } else {
                setCopy2("");
              }
            }, 1000);
          }

          const onEditPermission = async ({ id }) => {
            setLoading(true);
            try {
              const data = await getPermissions();
              if (data.india[4] == 1 || data.uk[4] == 1) {
                navigate(
                  `${configure.appUrl}sales/edit-contract/${cellProps.row.original.id}`,
                );
              } else {
                setAccessDenied(true);
              }
              setLoading(false);
            } catch (error) {
              console.log(error);
              setLoading(false);
            }
          };
          const onSendForApprove = async (id) => {
            Swal.fire({
              title: "Are you sure?",
              text: `You want to Send for Approve`,
              icon: "warning",
              showCancelButton: true,
            }).then(async (willDelete) => {
              if (willDelete.isConfirmed) {
                const formEntries = {
                  data_id: id,
                  status: 0,
                  type: 5,
                  user_id: localStorage.getItem("auth_id"),
                };
                const token = secureLocalStorage.getItem("auth_token");
                const res = await FetchNodePostData(
                  toggleLoading,
                  "approveList",
                  token,
                  formEntries,
                );
                if (res?.data?.success) {
                  Swal.fire({
                    icon: "success",
                    text: `Contact Send for Approve Successfully`,
                  });
                }
              }
            });
          };

          const datas = cellProps?.row?.original;
          let CredName = "";
          let CredEmail = "";
          if (datas?.related == "lead") {
            let personDetails;
            try {
              personDetails = JSON.parse(datas?.person_details);
            } catch (error) {
              personDetails = null;
            }
            const array = personDetails != null ? personDetails : [];
            const filter = array?.find((obj) => obj?.decision_maker == "on");
            CredName = filter?.person_name || "";
            CredEmail = filter?.person_email || "";
          } else if (datas?.related == "introducer") {
            CredName = datas?.company_name || "";
            CredEmail = datas?.person_details || "";
          } else if (datas?.related == "customer") {
            let personDetails;
            try {
              personDetails = JSON.parse(datas?.person_details);
            } catch (error) {
              personDetails = null;
            }
            const array = Array.isArray(personDetails) ? personDetails : [];
            const filter = array?.find(
              (obj) => obj?.primarycontact == "on",
            );
            CredName = filter?.name || "";
            CredEmail = filter?.email || "";
          }

          const contractId = cellProps.row.original.id;
          const summary = versionSummary[contractId] || {};
          const {
            original,
            latest_amendment,
            latest_signed_version,
            version_count,
            has_amendments,
            latest_is_unsigned_amendment,
          } = summary;

          const onOpenSignLink = (junkLink, isAmendment) => {
            if (!junkLink) {
              Swal.fire({
                icon: "info",
                text: "No signing link available for this version yet.",
              });
              return;
            }
            const path = isAmendment
              ? `sales/contract-amendment-sign/${junkLink}`
              : `sales/contract/${junkLink}`;
            window.open(`${configure.appUrl}${path}`, "_blank");
          };

          const onViewOriginal = () => {
            // Original contract view — uses the existing view-contract route,
            // since Version 1 is what tblcontract originally represented
            navigate(`${configure.appUrl}sales/view-contract/${contractId}`);
          };

          const onViewLatestAmendment = () => {
            if (!latest_amendment) return;
            window.open(
              `/sales/contract-amendment-view/${latest_amendment.id}`,
              "_blank",
            );
          };

          const canEditLatest =
            latest_is_unsigned_amendment &&
            latest_amendment &&
            ["draft", "pending_approval"].includes(latest_amendment.status);

          // return (
          //   <div className="d-flex">
          //     <Link
          //       to={`${configure.appUrl}sales/view-contract/${cellProps.row.original.id}`}
          //       title="View"
          //       className="btn btn-sm btn-outline-secondary me-1"
          //     >
          //       <i className="fas fa-eye "></i>
          //     </Link>
          //     {cellProps.row.original.approve == 0 ||
          //     cellProps.row.original.signature == null ? null : (
          //       <DownloadContract
          //         contract_id={cellProps.row.original.id}
          //         signature={cellProps.row.original.signature}
          //       />
          //     )}

          //       return (
          // <div>
          //   {/* ── Version badges ── */}
          //   <div className="d-flex gap-1 mb-2">
          //     <span className="badge bg-secondary" style={{ fontSize: "10px" }}>
          //       Original Contract
          //     </span>
          //     {has_amendments && (
          //       <span className="badge bg-purple" style={{ fontSize: "10px", background: "#752a97" }}>
          //         {version_count} Version{version_count !== 1 ? "s" : ""}
          //       </span>
          //     )}
          //   </div>

          //   {/* ── Original Contract row ── */}
          //   <div className="d-flex align-items-center gap-1 mb-1">
          //     <span style={{ fontSize: "11px", color: "#74788d", width: "48px" }}>Original</span>
          //     <button
          //       className="btn btn-sm btn-outline-secondary"
          //       title="View original signed contract"
          //       onClick={onViewOriginal}
          //     >
          //       <i className="fas fa-eye"></i>
          //     </button>
          //     {original?.junk_link && (
          //       <button
          //         className="btn btn-sm btn-outline-secondary"
          //         title="Open original signing link"
          //         onClick={() => onOpenSignLink(original.junk_link, false)}
          //       >
          //         <i className="fas fa-link"></i>
          //       </button>
          //     )}
          //     {/* Original is NEVER editable — no edit button rendered here */}
          //   </div>

          //   {/* ── Latest Version row (only if amendments exist) ── */}
          //   {has_amendments && (
          //     <div className="d-flex align-items-center gap-1 mb-2">
          //       <span style={{ fontSize: "11px", color: "#74788d", width: "48px" }}>Latest</span>

          //       <button
          //         className="btn btn-sm btn-outline-primary"
          //         title="View latest version"
          //         onClick={onViewLatestAmendment}
          //       >
          //         <i className="fas fa-eye"></i>
          //       </button>

          //       {latest_amendment?.junk_link && (
          //         <button
          //           className="btn btn-sm btn-outline-primary"
          //           title="Open latest signing link"
          //           onClick={() => onOpenSignLink(latest_amendment.junk_link, true)}
          //         >
          //           <i className="fas fa-link"></i>
          //         </button>
          //       )}

          //       {canEditLatest && (
          //         <button
          //           className="btn btn-sm btn-outline-warning"
          //           title="Edit latest (unsigned) version"
          //           onClick={() =>
          //             navigate(`${configure.appUrl}sales/contract-amendment/${contractId}?edit_amendment=${latest_amendment.id}`)
          //           }
          //         >
          //           <i className="fas fa-pencil-alt"></i>
          //         </button>
          //       )}

          //       <span
          //         className="badge ms-1"
          //         style={{
          //           fontSize: "9px",
          //           background:
          //             latest_amendment?.status === "signed" ? "#34c38f"
          //             : latest_amendment?.status === "rejected" ? "#f46a6a"
          //             : "#f1b44c",
          //         }}
          //       >
          //         {latest_amendment?.status?.replace(/_/g, " ") || "current"}
          //       </span>
          //     </div>
          //   )}

          //   {/* ── existing download / dropdown block stays below, unchanged ── */}
          //   {cellProps.row.original.approve == 0 || cellProps.row.original.signature == null ? null : (
          //     <DownloadContract
          //       contract_id={cellProps.row.original.id}
          //       signature={cellProps.row.original.signature}
          //     />
          //   )}

          //           <UncontrolledDropdown
          //             className="dropdown"
          //             style={{ width: "29px" }}
          //           >
          //             <DropdownToggle
          //               className="btn btn-sm btn-outline-secondary w-100"
          //               color="white"
          //             >
          //               <i className="mdi mdi-dots-horizontal"></i>
          //             </DropdownToggle>
          //             <DropdownMenu className="dropdown-menu-end">
          //               {/* <Link
          //                 title="edit"
          //                 onClick={() =>
          //                   onEditPermission({ id: cellProps.row.original.id })
          //                 }
          //                 // to={`${configure.appUrl}sales/edit-contract/${cellProps.row.original.id}`}
          //                 className="dropdown-item"
          //               >
          //                 <i className="fas fa-pencil-alt pe-1"></i> Edit Contract
          //               </Link> */}

          //               {!cellProps.row.original.is_locked ? (
          //                 <Link
          //                   title="edit"
          //                   onClick={() =>
          //                     onEditPermission({ id: cellProps.row.original.id })
          //                   }
          //                   className="dropdown-item"
          //                 >
          //                   <i className="fas fa-pencil-alt pe-1"></i> Edit Contract
          //                 </Link>
          //               ) : null}

          //               {cellProps.row.original.cancelled == 0 && (
          //                 <>
          //                   {cellProps.row.original.approve == 0 ||
          //                   cellProps.row.original.signature ==
          //                     null ? null : cellProps.row.original.junk_link ==
          //                     null ? (
          //                     <a
          //                       href="#"
          //                       title="link"
          //                       className="dropdown-item"
          //                       onClick={() =>
          //                         onGenerateLink(cellProps.row.original?.id)
          //                       }
          //                     >
          //                       <i className="fas fa-link pr-10"></i> Generate Link
          //                     </a>
          //                   ) : cellProps.row.original.approve == 2 ||
          //                     cellProps.row.original.junk_link == null ? (
          //                     <a
          //                       title="Send For Appove"
          //                       className="dropdown-item"
          //                       onClick={() =>
          //                         onSendForApprove(cellProps.row.original?.id)
          //                       }
          //                     >
          //                       <i className="fas fa-check pr-10"></i> Send For
          //                       Approve
          //                     </a>
          //                   ) : (
          //                     <>
          //                       {/* Live - earth.zithas.com */}
          //                       {/* Edemo Live - edemo.zithas.com/live */}
          //                       {/* edemo - edemo.zithas.com */}

          //                       <CopyToClipboard
          //                         text={`Contract Link: https://${configure.domain}/sales/contract/${cellProps.row.original.junk_link}\n\nCredentials to sign the contract:\n\nName: ${CredName}\nEmail: ${CredEmail}`}
          //                         onCopy={() => copyToClipBoard(1)}
          //                       >
          //                         <button className="dropdown-item copyBtn">
          //                           <i className="fas fa-copy pr-10"></i>
          //                           {copy?.length == 0 ? "Link & Credentials" : copy}
          //                         </button>
          //                       </CopyToClipboard>

          //                       <CopyToClipboard
          //                         text={`https://${configure.domain}/sales/contract/${cellProps.row.original.junk_link}`}
          //                         onCopy={() => copyToClipBoard(2)}
          //                       >
          //                         <button className="dropdown-item copyBtn">
          //                           <i className="fas fa-copy pr-10"></i>
          //                           {copy2?.length == 0 ? "Copy Link" : copy2}
          //                         </button>
          //                       </CopyToClipboard>
          //                     </>
          //                   )}
          //                 </>
          //               )}

          //               <button
          //                 onClick={() =>
          //                   onPermission(
          //                     onCancelContract,
          //                     cellProps.row.original.id,
          //                     cellProps.row.original.cancelled,
          //                   )
          //                 }
          //                 title="cancel"
          //                 className="dropdown-item"
          //               >
          //                 {cellProps.row.original.cancelled == 0 ? (
          //                   <>
          //                     <i className="fas fa-times-circle text-danger pe-1"></i>{" "}
          //                     Cancel Contract
          //                   </>
          //                 ) : (
          //                   <>
          //                     <i className="fas fa-check text-success pe-1"></i>{" "}
          //                     Re-initiate Contract
          //                   </>
          //                 )}
          //               </button>

          //               <button
          //                 onClick={() => getCancelLogs(cellProps.row.original.id)}
          //                 className="dropdown-item"
          //               >
          //                 <i className="fas fa-list text-danger pe-1"></i> Contract
          //                 Logs
          //               </button>

          //               <button
          //                 onClick={() =>
          //                   onPermission(onDeleteLead, cellProps.row.original.id)
          //                 }
          //                 title="delete"
          //                 className="dropdown-item"
          //               >
          //                 <i className="fas fa-trash-alt text-danger pe-1"></i> Delete
          //                 Contract
          //               </button>

          //               {/* <button
          //                 className="dropdown-item"
          //                 onClick={() => {
          //                   setAmendmentContract(cellProps.row.original);
          //                   setAmendmentModal(true);
          //                 }}
          //               >
          //                 <i className="fas fa-file-alt text-purple pe-1"></i> Create
          //                 Amendment
          //               </button> */}

          //               {/* ── Amendment items — ADD THESE ── */}
          //               {cellProps.row.original.is_locked == 1 && (
          //                 <button
          //                   className="dropdown-item"
          //                   onClick={() =>
          //                     navigate(
          //                       `${configure.appUrl}sales/contract-amendment/${cellProps.row.original.id}`,
          //                     )
          //                   }
          //                 >
          //                   <i className="fas fa-file-alt text-purple pe-1"></i>{" "}
          //                   Create Amendment
          //                 </button>
          //               )}

          //               <Link
          //                 className="dropdown-item"
          //                 to={`${configure.appUrl}sales/contract-amendments/${cellProps.row.original.id}`}
          //               >
          //                 <i className="fas fa-history text-info pe-1"></i> Amendment
          //                 History
          //               </Link>

          //               <div className="dropdown-divider"></div>
          //             </DropdownMenu>
          //           </UncontrolledDropdown>
          //         </div>
          //       );
          return (
            <div className="d-flex align-items-center gap-1">
              {/* ── Primary View button — smart default ── */}
              <button
                className="btn btn-sm btn-outline-secondary"
                title={has_amendments ? "View latest version" : "View contract"}
                onClick={has_amendments ? onViewLatestAmendment : onViewOriginal}
              >
                <i className="fas fa-eye"></i>
              </button>

              {/* ── Download (unchanged) ── */}
              {cellProps.row.original.approve == 0 || cellProps.row.original.signature == null ? null : (
                <DownloadContract
                  contract_id={cellProps.row.original.id}
                  signature={cellProps.row.original.signature}
                />
              )}

              {/* ── Everything else lives in the dropdown ── */}
              <UncontrolledDropdown className="dropdown" style={{ width: "29px" }}>
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                  {/* ── Version status header (replaces the two badges) ── */}
                  <div className="dropdown-header d-flex align-items-center gap-2">
                    <span>Contract Versions</span>
                    {has_amendments && (
                      <span
                        className="badge"
                        style={{ fontSize: "10px", background: "#752a97" }}
                      >
                        {version_count}
                      </span>
                    )}
                  </div>

                  {/* ── Original ── */}
                  <a className="dropdown-item d-flex align-items-center justify-content-between" onClick={onViewOriginal}>
                    <span><i className="fas fa-eye pe-1"></i> View Original</span>
                  </a>
                  {/* {original?.junk_link && (
          <a
            className="dropdown-item d-flex align-items-center justify-content-between"
            onClick={() => onOpenSignLink(original.junk_link, false)}
          >
            <span><i className="fas fa-link pe-1"></i> Original Sign Link</span>
          </a>
        )} */}
                  {original?.junk_link && (
                    <CopyToClipboard
                      text={`https://${configure.domain}/sales/contract/${original.junk_link}`}
                      onCopy={() => flashCopy(setCopyOrigSign)}
                    >
                      <button className="dropdown-item copyBtn">
                        <i className="fas fa-copy pe-1"></i>
                        {copyOrigSign || "Copy Original Sign Link"}
                      </button>
                    </CopyToClipboard>
                  )}

                  {/* ── Latest (only if amendments exist) ── */}
                  {has_amendments && (
                    <>
                      <div className="dropdown-divider"></div>
                      <div className="dropdown-header d-flex align-items-center gap-2">
                        <span>Latest Version</span>
                        <span
                          className="badge"
                          style={{
                            fontSize: "9px",
                            background:
                              latest_amendment?.status === "signed" ? "#34c38f"
                                : latest_amendment?.status === "rejected" ? "#f46a6a"
                                  : "#f1b44c",
                          }}
                        >
                          {latest_amendment?.status?.replace(/_/g, " ") || "current"}
                        </span>
                      </div>

                      <a className="dropdown-item" onClick={onViewLatestAmendment}>
                        <i className="fas fa-eye pe-1"></i> View Latest
                      </a>

                      {/* {latest_amendment?.junk_link && (
              <a
                className="dropdown-item"
                onClick={() => onOpenSignLink(latest_amendment.junk_link, true)}
              >
                <i className="fas fa-link pe-1"></i> Latest Sign Link
              </a>
            )} */}
                      {has_amendments && latest_amendment?.junk_link && (
                        <CopyToClipboard
                          text={`https://${configure.domain}/sales/contract-amendment-sign/${latest_amendment.junk_link}`}
                          onCopy={() => flashCopy(setCopyAmendSign)}
                        >
                          <button className="dropdown-item copyBtn">
                            <i className="fas fa-copy pe-1"></i>
                            {copyAmendSign || "Copy Latest Sign Link"}
                          </button>
                        </CopyToClipboard>
                      )}

                      {canEditLatest && (
                        <a
                          className="dropdown-item"
                          onClick={() =>
                            navigate(`${configure.appUrl}sales/contract-amendment/${contractId}?edit_amendment=${latest_amendment.id}`)
                          }
                        >
                          <i className="fas fa-pencil-alt pe-1"></i> Edit Latest
                        </a>
                      )}
                    </>
                  )}

                  <div className="dropdown-divider"></div>

                  {/* ── Existing contract actions (unchanged) ── */}
                  <Link
                    title="edit"
                    onClick={() => onEditPermission({ id: cellProps.row.original.id })}
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt pe-1"></i> Edit Contract
                  </Link>

                  {cellProps.row.original.cancelled == 0 && (
                    <>
                      {cellProps.row.original.approve == 0 ||
                        cellProps.row.original.signature == null ? null : cellProps.row.original.junk_link == null ? (
                          <a
                            href="#"
                            title="link"
                            className="dropdown-item"
                            onClick={() => onGenerateLink(cellProps.row.original?.id)}
                          >
                            <i className="fas fa-link pr-10"></i> Generate Link
                          </a>
                        ) : cellProps.row.original.approve == 2 || cellProps.row.original.junk_link == null ? (
                          <a
                            title="Send For Appove"
                            className="dropdown-item"
                            onClick={() => onSendForApprove(cellProps.row.original?.id)}
                          >
                            <i className="fas fa-check pr-10"></i> Send For Approve
                          </a>
                        ) : (
                        <>
                          <CopyToClipboard
                            text={`Contract Link: https://${configure.domain}/sales/contract/${cellProps.row.original.junk_link}\n\nCredentials to sign the contract:\n\nName: ${CredName}\nEmail: ${CredEmail}`}
                            onCopy={() => copyToClipBoard(1)}
                          >
                            <button className="dropdown-item copyBtn">
                              <i className="fas fa-copy pr-10"></i>
                              {copy?.length == 0 ? "Link & Credentials" : copy}
                            </button>
                          </CopyToClipboard>

                          <CopyToClipboard
                            text={`https://${configure.domain}/sales/contract/${cellProps.row.original.junk_link}`}
                            onCopy={() => copyToClipBoard(2)}
                          >
                            <button className="dropdown-item copyBtn">
                              <i className="fas fa-copy pr-10"></i>
                              {copy2?.length == 0 ? "Copy Link" : copy2}
                            </button>
                          </CopyToClipboard>
                        </>
                      )}
                    </>
                  )}

                  <button
                    onClick={() =>
                      onPermission(onCancelContract, cellProps.row.original.id, cellProps.row.original.cancelled)
                    }
                    title="cancel"
                    className="dropdown-item"
                  >
                    {cellProps.row.original.cancelled == 0 ? (
                      <><i className="fas fa-times-circle text-danger pe-1"></i> Cancel Contract</>
                    ) : (
                      <><i className="fas fa-check text-success pe-1"></i> Re-initiate Contract</>
                    )}
                  </button>

                  <button onClick={() => getCancelLogs(cellProps.row.original.id)} className="dropdown-item">
                    <i className="fas fa-list text-danger pe-1"></i> Contract Logs
                  </button>

                  <button
                    onClick={() => onPermission(onDeleteLead, cellProps.row.original.id)}
                    title="delete"
                    className="dropdown-item"
                  >
                    <i className="fas fa-trash-alt text-danger pe-1"></i> Delete Contract
                  </button>

                  {cellProps.row.original.is_locked == 1 && (
                    <button
                      className="dropdown-item"
                      onClick={() => navigate(`${configure.appUrl}sales/contract-amendment/${cellProps.row.original.id}`)}
                    >
                      <i className="fas fa-file-alt text-purple pe-1"></i> Create Amendment
                    </button>
                  )}

                  <Link
                    className="dropdown-item"
                    to={`${configure.appUrl}sales/contract-amendments/${cellProps.row.original.id}`}
                  >
                    <i className="fas fa-history text-info pe-1"></i> Amendment History
                  </Link>

                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          );
        },
      },
    ],
    [versionSummary],
  );

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Contract"} />

          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={filteredData}
                      onFilter={onFilter}
                      clearFilter={clearFilter}
                      onSaveFilter={onSaveFilter}
                      setAccessDenied={setAccessDenied}
                      setLoading={setLoading}
                      currentPage={currentPage}
                      limit={limit}
                      total={total}
                      keyword={keyword}
                      onPageChange={(page) =>
                        fetch(page, limit, keyword, assignFilter, countryFilter)
                      }
                      onLimitChange={(newLimit) =>
                        fetch(1, newLimit, keyword, assignFilter, countryFilter)
                      }
                      onSearch={(value) =>
                        fetch(1, limit, value, assignFilter, countryFilter)
                      }
                      getPermissions={getPermissions}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={reasonModal} size="md" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Provide reason for cancellation</h5>
          <button
            type="button"
            onClick={() => {
              setReasonModal(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <Form
            className="row"
            onSubmit={(e) => {
              e.preventDefault();
              onCancelContract(cancelData?.id, cancelData?.cancelled);
            }}
          >
            <div className="mb-3 col-12">
              <textarea
                type="textarea"
                placeholder="Enter reason to cancel.."
                required
                className="form-control "
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
            <div className="mt-2 text-end">
              <button className=" btn btn-purple">Submit</button>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal isOpen={logsModal} size="xl" centered>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Contract Cancellation Logs</h5>
          <button
            type="button"
            onClick={() => {
              setLogsModal(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <div
            className=" mb-2 mt-4"
            style={{
              maxHeight: "500px",
              overflow: "auto",
              scrollbarWidth: "thin",
            }}
          >
            <table className="table table-bordered mb-0">
              <thead
                className="table-light"
                style={{
                  position: "sticky",
                  top: "0",
                  left: "0",
                  width: "100%",
                }}
              >
                <tr>
                  <th>ID</th>
                  <th>Description</th>
                  <th>Done By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {logsData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.description}</td>
                    <td>{item.userName}</td>
                    <td>
                      {moment(item.created_at).format("DD-MM-YYYY | hh:mm A")}
                    </td>
                  </tr>
                ))}

                {!logsData.length ? (
                  <tr className="text-center">
                    <td colSpan={4}>No Log Found!</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>

      <ContractAmendmentModal
        isOpen={amendmentModal}
        toggle={() => setAmendmentModal(false)}
        contract={amendmentContract}
        onAmendmentSaved={(amendment) => {
          // optional: refresh list or show a toast
          console.log("Amendment saved:", amendment);
        }}
      />

      {/* Access Denied */}

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  );
};

export default Contract;
